const indexInit = {

}
const ddw = (state = indexInit, action) => {
  switch (action.type) {
    case "DOU_CHANNEL":
      return Object.assign({}, state, {
        ...action
      });
    default:
      return state;
  }
}

export default ddw